var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{staticClass:"post",attrs:{"value":_vm.promises.fetch}},[(_vm.component)?_c(_vm.component,{key:_vm.post.id,tag:"component",attrs:{"value":_vm.post}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }